<template>
  <layout-content :title="title">
    <template slot="header">
      {{ $t(`${$route.meta.title['code']}`, { name: title }) }}
    </template>
    <table-component :campaign="campaign" />
  </layout-content>
</template>
<script>
  import TableComponent from '@autocaller_v2/components/monitoring/monitoring-table.vue';
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      TableComponent
    },
    data() {
      return {
        title: '',
        campaign: {}
      };
    },
    created() {
      this.getCampaign();
    },
    methods: {
      ...mapActions('autocaller_v2/campaigns/tasks/table', ['getAsyncData']),
      getCampaign() {
        CampaignsService.getItem(this.$route.params.id).then((response) => {
          this.campaign = response || {};
          this.title = response.name;
        });
      }
    }
  };
</script>
